import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActionState, ComponentState, Relation, SelectedValue } from '../shared/model';
import { map, Observable, take } from 'rxjs';
import { ColumnFieldTitle, Condition, ConditionEvaluatorService, OfbizForm, OfbizList, RemoteFormData } from '@urbannex/ofbiz-forms';
import { UbsComponentStoreService } from '../ubs-component-store.service';
import { RelationService } from '../relation-container/relation.service';
import { ViewContainersService } from '../shared/services/view-containers.service';

@Component({
  selector: 'ubs-master-detail-container',
  templateUrl: './master-detail-container.component.html',
  styleUrls: ['./master-detail-container.component.scss']
})
export class MasterDetailContainerComponent implements OnInit,OnChanges{
  
  // @Input() state:Observable<ComponentState>;
  @Input() listForms:OfbizList[];
  @Input() addForms:OfbizForm[];
  @Input() incomingLink:string;
  @Input() activeLevel:number;
  @Input() action:ActionState;
  @Input() relations:Relation[];
  @Input() state:any;
  @Input() masterDetail:Relation;
  addForm:OfbizForm;
  listForm:OfbizList;
  listDetail:OfbizList;
  parameters:any;
  detailListFindParameters:any;
  appContext:string;
  addContainerTitle:string;
  listContainerTitle:string;
  detailListContainerTitle:string;
  lookupFieldResult:any;
  isDynamic = false;
  isListDetail = false;
  originalAddContainerTitle:string;

  /* @Input() set state(state:Observable<ComponentState>){
    state.pipe(take(1)).subscribe(componentState => {
      this.selectedValue = componentState.selectedValue;
      console.log(this.selectedValue);
    })
  } */

  selectedValue:SelectedValue;

  isSet = false;

  

  readonly listData$ = this.relationService.getSelectedRow().pipe(
    map(data => {
      console.log({ListData:data,Component:"MasterDetailContainerComponent",Comment:"Mapping ListData"});
      return data;
    })
  )
  constructor(
    private componentStore:UbsComponentStoreService, 
    private relationService:RelationService,
    private conditionEvaluatorService:ConditionEvaluatorService,
    private viewContainersService:ViewContainersService){

  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.masterDetail){
      console.log(changes.masterDetail.currentValue);
    }
  }
  /* @Input()
  set state(state:Observable<ComponentState>){
    state.subscribe(componentState => {
      this.state$ = componentState;
      this.title = "Listing "+componentState.workSpaceState;
      if(componentState.componentConfig.listForm){
        this.listForm = componentState.componentConfig.listForm;
        console.log({ListForm:this.listForm})
        this.fieldOptions = this.listForm?.fieldFormFields;
        if(this.listForm.remoteFormData != undefined && this.listForm.remoteFormData != null){
          this.remoteFormData = this.listForm.remoteFormData;
          console.log("Track RemoteFormData Change",this.listForm.remoteFormData);
        }else{
          this.remoteFormData = {
            formData:{
              formName:this.listForm.listFormName,
              formLocation:this.listForm.listFormLocation,
              viewIndex:this.listForm.viewIndex
            },
              endPoint:this.listForm.endPoint
          };
        }

        if(this.listForm.findParameters){
          console.log({findParameters:this.listForm.findParameters});
          this.listForm.findParameters.forEach(findParameter => {
            //console.log(findParameter);
            Object.keys(findParameter).forEach(key => {
              this.remoteFormData["formData"][key] = findParameter[key];
            })
          });
        }
        this.listOptions.formName = this.listForm.listFormName;
        this.listOptions.entityName = this.listForm.entityName;
        this.listOptions.formLocation = this.listForm.listFormLocation;
        this.listOptions.viewIndex = this.listForm.viewIndex;
        this.listOptions.endPoint = this.listForm.endPoint;
        if(this.listForm.columnFields){
          this.columnFields = this.listForm.columnFields;
        }
        if(this.listForm.labelColumn){
          this.listOptions.labelColumn = this.listForm.labelColumn;
        }
        if(this.listForm.listType){
          this.remoteFormData.formData.listType = this.listForm.listType;
        }
        if(this.listForm.columnFieldTitles && this.listForm.columnFieldTitles != undefined){
          this.columnFieldTitles = this.listForm.columnFieldTitles;
          console.log({columnFieldTitles:this.columnFieldTitles})
        }
        if(this.listForm.idFieldName){
          this.listOptions.idFieldName = this.listForm.idFieldName;
        }
        if(this.listForm.linkedList){
          this.listOptions.linkedList = this.listForm.linkedList;
          this.hasLinkedList = true;
        }
        if(componentState.componentConfig.idFieldName){
          this.listOptions.idFieldName = componentState.componentConfig.idFieldName;
        }
      }
    })
  }

  state$:ComponentState;
  title:string;
  listForm:OfbizList;
  fieldOptions:any = {};
  remoteFormData:RemoteFormData;
  listOptions:any = {};
  columnFields:any = {};
  columnFieldTitles:ColumnFieldTitle[];

  hasLinkedList = false; */

  ngOnInit(): void {
    this.selectedValue = undefined;
    this.componentStore.vm$.pipe()
    .subscribe(data => {
      this.selectedValue = data["selectedValue"];
      console.log(this.selectedValue)
      console.log(data.componentConfig);
      console.log(data.selectedMasterDetail);
      this.masterDetail = data.selectedMasterDetail;
      this.listForm = data.selectedMasterDetail.listForm;
      if(data.selectedMasterDetail.isListDetail){
        console.log("It's a listDetail",data.selectedMasterDetail.isListDetail)
        this.isListDetail = true;
        this.listDetail = data.selectedMasterDetail.listDetail;
      }else if(data.selectedMasterDetail.dynamic){
        this.isDynamic = true;
        console.log("It's a dynamic",data.selectedMasterDetail.dynamic)
        this.addForm = data.selectedMasterDetail.dynamicAddForms[0];
      }else{
        this.isListDetail = false;
        this.addForm = data.selectedMasterDetail.addForm;
        console.log(this.addForm);
      }
      this.appContext = data.componentConfig.appContext;
      this.listContainerTitle = data.selectedMasterDetail.listContainerTitle;
      this.detailListContainerTitle = data.selectedMasterDetail.detailListContainerTitle
      this.originalAddContainerTitle = data.selectedMasterDetail.addContainerTitle
      /* if(this.containsDollarBracketVariable(this.addContainerTitle)){
        this.addContainerTitle = this.addContainerTitle.replace(/\${(.*?)}/, (match, p1) => {
          return data.selectedMasterDetail.addContainerTitle;
        });
      }else{
        this.addContainerTitle = data.selectedMasterDetail.addContainerTitle;
      } */
      //this.addContainerTitle = data.selectedMasterDetail.addContainerTitle;
    });

    setTimeout(() => {
      this.isSet = true;      
    }, 500);

    this.listData$.subscribe((data:any[]) => {
      if(data){
        console.log(data);
        /**
         * Check if the addForm is selected dynamically.
         * If it is selected dynamically, then use the conditions to set the addForm to use
         */
        if(this.isDynamic && !this.isListDetail){
          let dynamicAddForms:OfbizForm[] = this.masterDetail.dynamicAddForms;
          for(let dynamicForm of dynamicAddForms){
            let condition:Condition = dynamicForm.dynamicFormConditions;
            let isMatch = this.conditionEvaluatorService.evaluate(data.reduce((acc, curr) => ({ ...acc, ...curr }), {}), condition);
            if(isMatch){
              this.addForm = dynamicForm;
            }
          }
        }
        this.createSelectedValueFromRowData(data);
        if(this.containsDollarBracketVariable(this.originalAddContainerTitle)){
          this.addContainerTitle = this.replaceDollarBracketVariable(this.originalAddContainerTitle, data);
        }else{
          this.addContainerTitle = this.originalAddContainerTitle;
        }

      }
    });
    
  }
  refreshRelatedLists(e){
    console.log({RefreshList:e,Component:"RelationContainerComponent",Comment:"Setting refreshList via relationService"})
    if(e == "success"){
      this.relationService.setRefreshList(true);
    }else{
      this.relationService.setRefreshList(false);
    }
    
  }

  createSelectedValueFromRowData(rowData:any[]){
    if(this.isListDetail){
      this.selectedValue = {type:"dummy",data:{formData:undefined}};
      let findParameters = this.listDetail.findParameters;
      findParameters.forEach(findParameter => {
        let key = Object.keys(findParameter)[0];
        let keyObject = rowData.find(element => element.hasOwnProperty(key));
        if(keyObject){
          findParameter[key] = keyObject[key];
        }
      })
      this.detailListFindParameters = findParameters;
      console.log(this.selectedValue,this.detailListFindParameters);
      //this.parameters = findParameters; 
      this.listDetail = {...this.listDetail,findParameters:findParameters}
    }else{
      console.log(this.addForm.breadCrumbData);
      let data = this.addForm.breadCrumbData.data;
      if(data.parameters){
        let paramKeys = Object.keys(data.parameters);
        console.log(rowData);
        paramKeys.forEach(key => {
          let keyObject = rowData.find(element => element.hasOwnProperty(key))
          if(keyObject){
            data.parameters[key] = keyObject[key]
          }
        })
      }
      let _selectedValue:SelectedValue = {
        event: "edit",
        label: "",
        data: {
          formData: {
            formName: this.addForm.formName,
            formLocation: this.addForm.formLocation,
          },
          endPoint: "",
          appContext: this.addForm.appContext ? this.addForm.appContext : this.appContext,
          parameters: data.parameters
        },
        type: ''
      }
      this.selectedValue = _selectedValue;
      this.parameters = data.parameters;
      console.log(this.selectedValue);
    }
    

  }

  containsDollarBracketVariable(str: string): boolean {
    const regex = /\${(.*?)}/;
    return regex.test(str);
  }

  replaceDollarBracketVariable(str: string, variables: Array<{ [key: string]: string }>): string {
    return str.replace(/\${(.*?)}/g, (match, p1) => {
      for (const variable of variables) {
        if (variable.hasOwnProperty(p1)) {
          return variable[p1];
        }
      }
      return match; // Return the original match if no replacement is found
    });
  }
  
  /* // Usage example
  const originalString = "Hello ${name}, welcome!";
  const actualValue = "John";
  const resultString = this.checkAndReplaceDollarVariable(originalString, actualValue);
  console.log(resultString); // Output: "Hello John, welcome!" */
}
